// AI-assisted. Reviewed by: [name] on [date]. Tests: ✅. No unreviewed auth changes.
import { create } from 'zustand';

interface ScopeState {
  scope: 'mine' | 'team';
  setScope: (scope: 'mine' | 'team') => void;
}

export const useScopeStore = create<ScopeState>((set) => ({
  scope: 'mine',
  setScope: (scope) => set({ scope }),
}));
